import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Login.css";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import baseURL from "../../url";
import { useNavigate } from "react-router-dom";

export default function Login({ setUser }) {
    const [usuario, setUsuario] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();

        try {
            const payload = { usuario, password };

            const response = await fetch(`${baseURL}?url=login`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            const data = await response.json();

            if (data.res === 1) {
                toast.success(data.mensaje);

                // GUARDAR USER
                localStorage.setItem("user", JSON.stringify(data.user));

                // ⚠️ GUARDAR TOKEN
                localStorage.setItem("token", data.token);

                setUser(data.user); // MUY IMPORTANTE

                setLoading(true);

                setTimeout(() => {
                    navigate("/inicio");
                }, 800);
            } else {
                toast.error(data.mensaje);
            }
        } catch (error) {
            toast.error(error.message);
        }
    };

    return (
        <div className="loginWrapper">
            <div className="formContain">
                <ToastContainer />
                <ToastContainer autoClose={1000} />
                <h2>Administrador</h2>

                {/* ===== LOGO EN CÍRCULO ===== */}
                <div className="logoAtuh">
                    <FontAwesomeIcon icon={faUser} className="logoIcon" />
                </div>

                <form onSubmit={handleLogin} className="formAuth">
                    <div className="inputsAuth">
                        <input
                            type="text"
                            value={usuario}
                            onChange={(e) => setUsuario(e.target.value)}
                            required
                            placeholder="Usuario"
                            disabled={loading}
                        />
                    </div>
                    <div className="inputsAuth">
                        <div className="deFlexInputs">
                            <input
                                type={showPassword ? "text" : "password"}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                placeholder="Contraseña"
                                disabled={loading}
                            />
                            <button
                                type="button"
                                onClick={() => setShowPassword(!showPassword)}
                                disabled={loading}
                            >
                                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                            </button>
                        </div>
                    </div>

                    <button type="submit" className="btn" disabled={loading}>
                        {loading ? "Ingresando..." : "Iniciar Sesión"}
                    </button>
                </form>
            </div>
        </div>
    );
}
